import React, { Component } from 'react';
import axios from 'axios';
import { getToken } from '../../functions/app_functions.js';
import { trackEvent } from "../../utils/analytics";
import ForminputText from '../forminput/forminput_text.js';
import ForminputEmail from '../forminput/forminput_email.js';
import ForminputPassword from '../forminput/forminput_password.js';
import GoogleAuthButton from "./google_auth_button.js";


export default class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            page: 1,
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp"
        };
        this.setFormValue = this.setFormValue.bind(this);
        this.setPage = this.setPage.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
    }


    setFormValue(label, value) {
        // Update state
        this.setState({
            [label]: value
        });
    }


    setPage(value) {
        // Update state
        this.setState({
            page: value
        });
    }


    validateForm() {
        var return_value = true;
        if (!this.state.name || this.state.name == "" || this.state.name.length > 50) {
            var name = "Data error";
            var message = "Please provide your name with up to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (!this.state.username || this.state.username == "" || this.state.username.length > 20) {
            var name = "Data error";
            var message = "Please provide a username with up to 20 characters.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (!this.state.email || this.state.email == "" || this.state.email.length > 100 || !this.validateEmail(this.state.email)) {
            var name = "Data error";
            var message = "Please provide your email.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (!this.state.password || this.state.password == "" || this.state.password.length < 5 || this.state.password.length > 50) {
            var name = "Data error";
            var message = "Please provide a password with 5 to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (this.state.password != this.state.password2) {
            var name = "Data error";
            var message = "Your passwords don't match.";
            this.props.setError(name, message);
            return_value = false;
        }
        return return_value;
    }


    validateEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }


    async submitRequest() {
        this.props.setLoading();
        const status = this.validateForm();
        const params = new URLSearchParams(this.props.location.search);
        const redirect = params.get("redirect") || "/"; // Default to home if no redirect
        try {
            if (status) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/signup", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        name: this.state.name,
                        username: this.state.username,
                        email: this.state.email,
                        password: this.state.password
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                const signup_data = data.signup_data;
                const login_data = data.login_data;
                if (signup_data.status == true) {
                    // Track event
                    trackEvent("user_signup", { user_id: login_data.id });
                    // Login user
                    this.props.setLogin(true, login_data.id, login_data.email, login_data.token, redirect, login_data.admin_role);
                } else {
                    if (signup_data.error == "username") {
                        // Track error
                        var name = "Error";
                        var message = "This username is already in use. Please choose a different username.";
                        this.props.setError(name, message);
                    } else if (signup_data.error == "email") {
                        // Track error
                        var name = "Error";
                        var message = "This email is already in use. Please choose a different email or reset your password.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "Server error";
                        var message = "Could not sign up. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
                this.props.unsetLoading();
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not sign up. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Signup_submitRequest");
            this.props.unsetLoading();
        }
    }


    render() {

        return (
            <div className="content-container login-container">
                <img src={this.state.background_url} alt={""} className={"login__background"} />
                <div className="login__background login__background--overlay"></div>
                <form
                    className="login-wrapper"
                    onSubmit={e => {
                        e.preventDefault();
                        // Only submit on page 2
                        if (this.state.page === 2) {
                            this.submitRequest();
                        }
                    }}
                >

                    {this.state.page === 1 &&
                        <div className="login">
                            <div className="login__element login__title text-subtitle">
                                Sign up
                            </div>

                            <div className="login__element form__content__element">
                                Choose how you would like to sign up.
                            </div>

                            <div className="login__element form__content__element form__content__buttonbox">
                                <button
                                    type="button"
                                    onClick={() => this.setPage(2)}
                                    className="form__content__buttonbox__button button button-primary"
                                >
                                    Proceed with email
                                </button>
                                <GoogleAuthButton
                                    label={"Sign up with Google"}
                                />
                            </div>
                        </div>
                    }

                    {this.state.page === 2 &&
                        <div className="login">
                            <div className="login__element login__title text-subtitle">
                                Sign up
                            </div>

                            <div className="login__element form__content__element form__content__input">
                                <ForminputText
                                    name={"name"}
                                    label={"Name"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"Your name"}
                                />
                            </div>

                            <div className="login__element form__content__element form__content__input">
                                <ForminputText
                                    name={"username"}
                                    label={"Username"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"A unique username by which others can find you"}
                                />
                            </div>

                            <div className="login__element form__content__element form__content__input">
                                <ForminputEmail
                                    name={"email"}
                                    label={"Email"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"Your email address"}
                                />
                            </div>

                            <div className="login__element form__content__element form__content__input">
                                <ForminputPassword
                                    name={"password"}
                                    label={"Password"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"Your password"}
                                />
                            </div>

                            <div className="login__element form__content__element form__content__input">
                                <ForminputPassword
                                    name={"password2"}
                                    label={"Password confirmation"}
                                    default_value={""}
                                    setFormValue={this.setFormValue.bind(this)}
                                    required={true}
                                    note={"Your password"}
                                />
                            </div>

                            <div className="login__element form__content__element form__content__buttonbox">
                                <button
                                    type="submit"
                                    className="form__content__buttonbox__button button button-primary"
                                >
                                    Sign up
                                </button>
                                {/* <div onClick={() => this.setPage(1)} className="form__content__buttonbox__button button button-primary-light">
                                    Go back
                                </div> */}
                            </div>
                        </div>
                    }

                </form>
            </div>
        )
    }
}
